import { render, staticRenderFns } from "./Riskprofile.vue?vue&type=template&id=3d5798be&"
import script from "./Riskprofile.vue?vue&type=script&lang=js&"
export * from "./Riskprofile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports